export default function ScrollToTopButton() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
  };

  return (
    <button className="scroll-to-top" onClick={scrollToTop}>
      ↑ Back to Top
    </button>
  );
}
